<template>
  <div class="pwdSetting">
    <!-- 新增/修改门禁弹窗 -->
    <el-dialog class="dialog816" title="修改密码" :visible.sync="isDialogShow" :close-on-click-modal="false">
      <el-form :model="pwdForm" label-width="160px" ref="pwdForm" :rules="rules">
         <el-row>
        <el-col :span="15">
        <el-form-item label="原密码" prop="pwd">
          <el-input v-model="pwdForm.oldPassword" autocomplete="off" type="password"></el-input>
        </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="15">
        <el-form-item label="新密码" prop="pwd">
          <el-input v-model="pwdForm.newPassword" autocomplete="off" type="password"></el-input>
        </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="15">
        <el-form-item label="确认密码" prop="pwdConform">
          <el-input v-model="pwdForm.pwdConform" autocomplete="off" type="password"></el-input>
        </el-form-item>
        </el-col>
      </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isDialogShow=false">取 消</el-button>
        <el-button type="primary" @click="savePwdClick()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { modifySysUserPasswordService } from "@/services/loginService";
export default {
  name: "AccountSetting",
  data() {
    return {
      isDialogShow: false,
      pwdForm: {
        newPassword:"",  //新密码
        oldPassword: "",  //旧密码
        pwdConform: ""    
      },
      userCode: "",
      rules: {
        oldPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur"
          },
          {
            pattern: /^[0-9a-zA-Z]+$/,
            message: "只能输入数字或英文",
            trigger: "blur"
          }
        ],
        newPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur"
          },
          {
            pattern: /^[0-9a-zA-Z]+$/,
            message: "只能输入数字或英文",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showPwdDialog(userCode) {
      this.userCode  = sessionStorage.getItem("currentUserId");
      this.isDialogShow = true;
    },
 
    /* 修改密码 保存按钮回调 */
    savePwdClick() {
      this.$refs.pwdForm.validate(res => {
        if (res) {
          if (this.pwdForm.newPassword != this.pwdForm.pwdConform) {
            this.$message.error("两次密码输入不一致，请重新输入");
            return;
          }         
          //调用修改
          this.pwdForm.userId=this.userCode;
          this.modifySysUserPassword(this.pwdForm);
        }
      });
    },
    /* 修改密码请求 */
    modifySysUserPassword(modifyInfo) {
      modifySysUserPasswordService(modifyInfo).then(
        res => {
          if (res.code == 10000000) {
            this.$alert("密码修改成功", "提示", {
              confirmButtonText: "确定"
            });
            this.isDialogShow = false;
          }else if(res.code>20000000){
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }else{
             this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败"+err.message);
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.pwdSetting {
  /deep/.el-dialog {

    /deep/.el-icon-view:before {
      display: none;
    }
  }
}
</style>
